module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/form-element/quatity-style1/quatity-style1.component.scss
// module id = ./src/app/features/form-element/quatity-style1/quatity-style1.component.scss
// module chunks = main